import { useState, useCallback, useRef } from 'react';

interface StatusOverlayState {
  message: string;
  visible: boolean;
}

const HIDDEN: StatusOverlayState = { message: '', visible: false };
const DEFAULT_DURATION = 1500;

export function useStatusOverlay(duration = DEFAULT_DURATION) {
  const [status, setStatus] = useState<StatusOverlayState>(HIDDEN);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const show = useCallback(
    (message: string) => {
      if (timerRef.current) clearTimeout(timerRef.current);

      setStatus({ message, visible: true });

      timerRef.current = setTimeout(() => {
        setStatus((prev) => ({ ...prev, visible: false }));
      }, duration);
    },
    [duration],
  );

  return { status, show };
}
